import { createSelector } from '@reduxjs/toolkit';

const selectWorkOrders = state => state.orderDetails;

export const selectIsLoading = createSelector(
  selectWorkOrders,
  state => state.isLoading
);

export const selectIsEditVehicleLoading = createSelector(
  selectWorkOrders,
  state => state.isEditVehicleLoading
);

export const selectIsDeleteServiceLoading = createSelector(
  selectWorkOrders,
  state => state.isDeleteServiceLoading
);

export const selectAddServiceModalOpen = createSelector(
  selectWorkOrders,
  state => state.addServiceModalOpen
);

export const selectDeleteServiceStatus = createSelector(
  selectWorkOrders,
  state => state.deleteServiceStatus
);

export const selectDeleteServiceModalOpen = createSelector(
  selectDeleteServiceStatus,
  state => !!state
);

export const selectWorkOrder = createSelector(
  selectWorkOrders,
  state => state.workOrder
);

export const selectAddServiceError = createSelector(
  selectWorkOrders,
  state => state.addServiceError
);

export const selectEditVehicleModalOpen = createSelector(
  selectWorkOrders,
  state => state.editVehicleModalOpen
);

export const selectPrices = createSelector(
  selectWorkOrders,
  state => state.prices
);

export const selectIsAddServiceLoading = createSelector(
  selectWorkOrders,
  state => state.isAddServiceLoading
);

export const selectIsLoadingPdf = createSelector(
  selectWorkOrders,
  state => state.isLoadingPdf
);

export const selectDataPdf = createSelector(
  selectWorkOrders,
  state => state.dataPdf
);

export const stepStatusChangeApiIsLoading = createSelector(
  selectWorkOrders,
  state => state.changeStepStatus.isApiLoading
);

export const selectIsLoadingEditCompletion = createSelector(
  selectWorkOrders,
  state => state.promiseDate.isLoadingEditCompletion
);

export const selectPromiseDateStatus = createSelector(
  selectWorkOrders,
  state => state.promiseDate.status
);

export const selectIsLoadingAddSurvey = createSelector(
  selectWorkOrders,
  state => state.isLoadingAddSurvey
);

export const selectSurveySentStatus = createSelector(
  selectWorkOrders,
  state => state.surveySentStatus
);

export const selectAddSurveyModalOpen = createSelector(
  selectWorkOrders,
  state => state.addSurveyModalOpen
);

export const selectShowCancelSuccesSnackBar = createSelector(
  selectWorkOrders,
  state => state.changeStepStatus.status === 200
);

export const selectShowCancelErrorSnackBar = createSelector(
  selectWorkOrders,
  state =>
    !!state.changeStepStatus.status && state.changeStepStatus.status !== 200
);

export const isAddNoteApiLoading = createSelector(
  selectWorkOrders,
  state => state.addNewNote.isNoteLoading
);

export const selectIsProcessingAction = createSelector(
  selectWorkOrders,
  state => state.isProcessingAction
);

export const selectApproveDialogOpened = createSelector(
  selectWorkOrders,
  state => state.approveDialogOpened
);

export const selectShowDeclinedSuccesSnackBar = createSelector(
  selectWorkOrders,
  state => !!state.declinedSuccesful
);

export const selectShowDeclinedErrorSnackBar = createSelector(
  selectWorkOrders,
  state => state.declinedSuccesful !== null && !state.declinedSuccesful
);

export const selectDeclineConfirmOpen = createSelector(
  selectWorkOrders,
  state => state.declineConfirmOpen
);
